var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSidebarCone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_845_16871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.125 19.1167L9.4643 3.76568C9.51125 3.63081 9.59903 3.51391 9.71546 3.43121C9.83188 3.34851 9.97117 3.30412 10.114 3.3042H11.886C12.0288 3.30412 12.1681 3.34851 12.2845 3.43121C12.401 3.51391 12.4888 3.63081 12.5357 3.76568L17.875 19.1167",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9375 19.1167H2.0625",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2879 8.8042H7.71191",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2007 14.3042H5.79883",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_845_16871"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0 0.554199)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSidebarCone);
export default __webpack_public_path__ + "static/media/icon-sidebar-cone.5d5d8d8933bcd19a3e0272b7795e688c.svg";
export { ForwardRef as ReactComponent };